import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { DateRange } from "./dateRange";
import { OccupationalRiskPreventionDirectKpiCfg, OccupationalRiskPreventionDirectKpiCfgService } from "./occupationalRiskPreventionDirectKpiCfg.service";
import { OccupationalRiskPreventionDirectKpiService } from "./occupationalRiskPreventionDirectKpiService";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

export class FitActiveWorkersWoMedicalExaminationDirectServiceData {
    public consultant: number;
    public office: number;
    public updateTimestamp: Date;
}

@Injectable()
export class FitActiveWorkersWoMedicalExaminationDirectService extends OccupationalRiskPreventionDirectKpiService<FitActiveWorkersWoMedicalExaminationDirectServiceData> {
    public getClassName() { return "FitActiveWorkersWoMedicalExaminationDirectService"; }

    constructor(
        private serviceCfg: OccupationalRiskPreventionDirectKpiCfgService,
        private apigeeService: ApigeeService,
        private impersonationService: ImpersonationService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<FitActiveWorkersWoMedicalExaminationDirectServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: FitActiveWorkersWoMedicalExaminationDirectServiceData = null;
            try {
                let cfg: OccupationalRiskPreventionDirectKpiCfg = this.serviceCfg.getCfg();
                let { begin, end } = this.getDateRange(DateRange.CurrentWeek);
                let url = cfg.fitActiveWorkersWoMedicalExaminationDirect.summaryEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.post<FitActiveWorkersWoMedicalExaminationDirectServiceData>(url, this.impersonationService.getNifImpersonate()).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
